var Anhui = "An Huy";
var Beijing = "Bắc Kinh";
var Chongqing = "Trùng Khánh";
var Fujian = "Phúc Kiến";
var Gansu = "Cam Túc";
var Guangdong = "Quảng Đông";
var Guangxi = "Quảng Tây";
var Guizhou = "Quý Châu";
var Hainan = "Hải Nam";
var Hebei = "Hà Bắc";
var Heilongjiang = "Hắc Long Giang";
var Henan = "Hà Nam";
var Hubei = "Hồ Bắc";
var Hunan = "Hồ Nam";
var Jiangsu = "Giang Tô";
var Jiangxi = "Giang Tây";
var Jilin = "Cát Lâm";
var Liaoning = "Liêu Ninh";
var Ningxia = "Ninh Hạ";
var Qinghai = "Thanh Hải";
var Shaanxi = "Thiểm Tây";
var Shandong = "Sơn Đông";
var Shanghai = "Thượng Hải";
var Shanxi = "Sơn Tây";
var Sichuan = "Tứ Xuyên";
var Tianjin = "Thiên Tân";
var Tibet = "Tây Tạng";
var Xinjiang = "Tân Cương";
var Yunnan = "Vân Nam";
var Zhejiang = "Chiết Giang";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "Nội Mông",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
